export const tradesSumFLocation = "/foreign/sumtrades";
